import { render, staticRenderFns } from "./BannerWithBot.vue?vue&type=template&id=716f4e46&"
import script from "./BannerWithBot.vue?vue&type=script&lang=js&"
export * from "./BannerWithBot.vue?vue&type=script&lang=js&"
import style0 from "./BannerWithBot.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports